import { DeliveryStrategyType } from '../../../../../../@types/deliveries.enum';

export const validateAgainstGiftcards = (strategies?: Deliveries.IShippingStrategy[]) => {
  return strategies?.filter((strategy) => {
    const buckets = strategy.shippingBuckets.filter(
      (b) => !b.isDropShipping && !b.items.every((i) => i.m3Id?.toLowerCase().startsWith('pre')),
    );

    const isAllItems = (strategy.type as DeliveryStrategyType) === DeliveryStrategyType.AllItems;

    return isAllItems || buckets.length > 1;
  });
};
